import { useState, useEffect, useCallback } from 'react'

export default function useExpandedLeagues({ fromLeague, leagueId }) {
  const [expandedLeagueIds, setExpandedLeagueIds] = useState(new Set())

  useEffect(() => {
    // Auto-expand the league the user navigated from so it's immediately visible.
    if (fromLeague && leagueId) {
      setExpandedLeagueIds((prev) => new Set([...prev, leagueId]))
    }
  }, [fromLeague, leagueId])

  const toggleLeague = useCallback((leagueIdToToggle) => {
    setExpandedLeagueIds((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(leagueIdToToggle)) {
        newSet.delete(leagueIdToToggle)
      } else {
        newSet.add(leagueIdToToggle)
      }
      return newSet
    })
  }, [])

  return { expandedLeagueIds, toggleLeague }
}
